import React, { useEffect, useState } from 'react';
import TrustedTesterApplication from '../components/TrustedTesterApplication';
import VendorTesterDashboard from '../components/VendorTesterDashboard';
import TrustedTesterProfile from '../components/TrustedTesterProfile';
import TestingWorkflow from '../components/TestingWorkflow';

export default function TrustedTesterProgramPage() {
  const [selectedView, setSelectedView] = useState<'application' | 'dashboard' | 'profile' | 'workflow'>('application');

  useEffect(() => {
    document.body.classList.add('analytics-page');
    return () => {
      document.body.classList.remove('analytics-page');
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', paddingTop: '60px' }}>
      <div style={{ 
        backgroundColor: '#2d3748', 
        borderBottom: '1px solid #e2e8f0',
        padding: '1rem 0',
        position: 'sticky',
        top: '60px',
        zIndex: 100
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#1a202c', marginBottom: '1rem' }}>
            Trusted Tester Program Management
          </h1>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {[
              { key: 'application', label: 'Tester Application' },
              { key: 'dashboard', label: 'Vendor Dashboard' },
              { key: 'profile', label: 'Tester Profile' },
              { key: 'workflow', label: 'Testing Workflow' }
            ].map(view => (
              <button
                key={view.key}
                onClick={() => setSelectedView(view.key as any)}
                style={{
                  padding: '0.5rem 1rem',
                  backgroundColor: selectedView === view.key ? '#3b82f6' : 'white',
                  color: selectedView === view.key ? 'white' : '#374151',
                  border: '1px solid #d1d5db',
                  borderRadius: '0.375rem',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                {view.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div style={{ minHeight: 'calc(100vh - 120px)' }}>
        {selectedView === 'application' && <TrustedTesterApplication />}
        {selectedView === 'dashboard' && (
          <VendorTesterDashboard vendorId="vendor-001" subscriptionTier="professional" />
        )}
        {selectedView === 'profile' && (
          <TrustedTesterProfile testerId="tester-001" isOwnProfile={true} />
        )}
        {selectedView === 'workflow' && (
          <TestingWorkflow requestId="req-001" userType="staff" userId="staff-001" />
        )}
      </div>
    </div>
  );
}